import { TabPane } from './src/TabPane.js';
import { Tabs as Tabs$1 } from './src/Tabs.js';

const Tabs = Tabs$1;
Tabs.TabPane = TabPane;

export { Tabs };
//# sourceMappingURL=index.js.map
